import { render, staticRenderFns } from "./MakeHomeworkContainer.vue?vue&type=template&id=1b7a4224"
import script from "./MakeHomeworkContainer.vue?vue&type=script&lang=js"
export * from "./MakeHomeworkContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports